<div fxLayoutAlign="center center" class="not-found-container">
    <mat-card>

        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-icon>error_outline</mat-icon>
            <h1 class="mat-h1">{{heading}}</h1>
            <div>{{message}}</div>
        </div>
        
    </mat-card>
</div>
